import "../styles/Footer.css";

function Footer() {
    return (
        <>
            <footer>
                <div className="createdBy">Built by - VISHANK WAGH</div>
                <div className="copy">&copy; Copyright 2026</div>
            </footer>
        </>
    )
}

export default Footer;